if (!customElements.get('product-modal')) {
  customElements.define('product-modal', class ProductModal extends ModalDialog {
    constructor() {
      super();
      this.pointers = new Map();
      this.scale = 1;
    }

    hide() {
      this.pointers.clear();
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      const id = this.openedBy?.getAttribute('data-media-id');
      const active = [...this.querySelectorAll('[data-media-id]')].find(item => item.dataset.mediaId === id);
      if (!active) return;
      this.querySelectorAll('[data-media-id]').forEach(item => item.classList.toggle('active', item === active));
      this.container = this.querySelector('[role="document"]');
      if (!this.container) return;
      this.image = active.tagName === 'IMG' ? active : null;
      active.scrollIntoView({block:'nearest'});
      if (this.image) {
        this.image.loading = 'eager';
        this.image.draggable = false;
        this.scale = 1;
        this.pointers.clear();
        this.setupZoom();
        const image = this.image;
        const fit = () => { if (this.image === image && this.hasAttribute('open')) this.applyScale(this.scale, true); };
        if (image.complete && image.naturalWidth) fit();
        else image.addEventListener('load', fit, {once:true});
      } else {
        if (this.controls) this.controls.hidden = true;
        const template = active.querySelector('template');
        if (active.nodeName === 'DEFERRED-MEDIA' && template?.content.querySelector('.js-youtube')) active.loadContent();
      }
    }

    setupZoom() {
      if (!this.controls) {
        this.controls = document.createElement('div');
        this.controls.className = 'doma-zoom-controls';
        this.controls.addEventListener('pointerup', event => event.stopPropagation());
        for (const [label, text, action] of [
          ['Diminuir zoom', '−', () => this.applyScale(this.scale / 1.25)],
          ['Restaurar zoom', '100%', () => this.applyScale(1, true)],
          ['Aumentar zoom', '+', () => this.applyScale(this.scale * 1.25)]
        ]) {
          const button = document.createElement('button');
          button.type = 'button'; button.setAttribute('aria-label', label); button.textContent = text;
          button.addEventListener('click', action); this.controls.append(button);
        }
        this.querySelector('[role="dialog"]').append(this.controls);
        this.container.addEventListener('wheel', event => {
          if (!this.image) return;
          event.preventDefault();
          this.applyScale(this.scale * (event.deltaY < 0 ? 1.15 : 1 / 1.15));
        }, {passive:false});
        this.container.addEventListener('keydown', event => {
          if (!this.image || !['+','=','-','0'].includes(event.key)) return;
          event.preventDefault();
          this.applyScale(event.key === '0' ? 1 : this.scale * (event.key === '-' ? 0.8 : 1.25), event.key === '0');
        });
        this.container.addEventListener('pointerdown', event => {
          if (!this.image || event.target !== this.image) return;
          this.container.setPointerCapture?.(event.pointerId);
          this.pointers.set(event.pointerId, {x:event.clientX,y:event.clientY});
          this.drag = {x:event.clientX,y:event.clientY,left:this.container.scrollLeft,top:this.container.scrollTop};
          this.pinchDistance = this.distance();
          this.pinchScale = this.scale;
        });
        this.container.addEventListener('pointermove', event => {
          if (!this.image || !this.pointers.has(event.pointerId)) return;
          event.preventDefault();
          this.pointers.set(event.pointerId, {x:event.clientX,y:event.clientY});
          const distance = this.distance();
          if (distance && this.pinchDistance) this.applyScale(this.pinchScale * distance / this.pinchDistance);
          else if (this.drag) {
            this.container.scrollLeft = this.drag.left + this.drag.x - event.clientX;
            this.container.scrollTop = this.drag.top + this.drag.y - event.clientY;
          }
        }, {passive:false});
        const release = event => {
          if (this.image) event.stopPropagation();
          this.pointers.delete(event.pointerId); this.pinchDistance = 0;
          const remaining = [...this.pointers.values()][0];
          this.drag = remaining ? {x:remaining.x,y:remaining.y,left:this.container.scrollLeft,top:this.container.scrollTop} : null;
        };
        this.container.addEventListener('pointerup', release);
        this.container.addEventListener('pointercancel', release);
        this.container.addEventListener('lostpointercapture', release);
      }
      this.controls.hidden = false;
    }

    distance() {
      if (this.pointers.size !== 2) return 0;
      const [a,b] = [...this.pointers.values()];
      return Math.hypot(a.x-b.x, a.y-b.y);
    }

    applyScale(value, reset = false) {
      if (!this.image || !this.container) return;
      const scale = Math.max(1, Math.min(4, value));
      if (!this.image.naturalWidth) { this.scale = scale; return; }
      const availableWidth = Math.max(1, this.container.clientWidth - 32);
      const availableHeight = Math.max(1, this.container.clientHeight - 144);
      const base = Math.min(availableWidth, availableHeight * this.image.naturalWidth / this.image.naturalHeight);
      const ratio = scale / this.scale;
      const x = (this.container.scrollLeft + this.container.clientWidth / 2) * ratio - this.container.clientWidth / 2;
      const y = (this.container.scrollTop + this.container.clientHeight / 2) * ratio - this.container.clientHeight / 2;
      this.image.style.width = base * scale + 'px';
      this.image.style.maxWidth = 'none';
      this.image.style.height = 'auto';
      this.image.style.margin = '0 auto';
      this.scale = scale;
      this.container.scrollLeft = reset ? 0 : Math.max(0, x);
      this.container.scrollTop = reset ? 0 : Math.max(0, y);
      this.controls.children[1].textContent = Math.round(scale * 100) + '%';
      this.dataset.domaZoom = String(scale);
    }
  });
}


